import { render } from "./AddLottery.vue?vue&type=template&id=607c95fd"
import script from "./AddLottery.vue?vue&type=script&lang=js"
export * from "./AddLottery.vue?vue&type=script&lang=js"

import "./AddLottery.vue?vue&type=style&index=0&id=607c95fd&scope=true&lang=css"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__